class NSSCartTemplate extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {
      buyboxSummaries: document.querySelectorAll(`nss-buybox-summary-variant`),
      buyboxStickyATCs: document.querySelectorAll(`nss-buybox-sticky-atc-variant`),
    };
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Cart Template] Connected.`);

    this.initCartTemplate();
  }

  async apiAddToCart(e) {
    const formData = new FormData(e.target);

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async apiUpdate(updates) {
    return fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async apiChange(changes) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(changes),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async fetchCartSection() {
    const parser = new DOMParser(),
      sectionID = this.getAttribute(`nss-parent-section-id`);

    let markup = await (await fetch(`?section_id=${sectionID}`)).text();

    return parser.parseFromString(markup, "text/html");

    // (new DOMParser).parseFromString(await (await fetch(`?section_id=nss-cart-drawer`)).text(), "text/html")
  }

  updateItemCount(sectionEl) {
    const newProductListEl = sectionEl.querySelector(`.nss-cart__items`),
      itemCountEls = document.querySelectorAll(`[nss-cart-count]`);

    itemCountEls.forEach((itemCountEl) => {
      itemCountEl.innerHTML = newProductListEl.getAttribute(`nss-cart-item-count`);
    });

    this.updateCountBadges(newProductListEl.getAttribute(`nss-cart-item-count`));
  }

  updateCountBadges(result) {
    const count = parseInt(result);
    if (this.debug) console.log(`[NSS][Cart Template] Updating badges, count:`, count);
    if (count < 100) {
      const countEls = document.querySelectorAll(`[nss-cart-badge-count], [lsg-cart-count], [nss-cart-count]`);
      countEls.forEach((countEl) => {
        countEl.innerHTML = count;
      });
    }
  }

  reloadElements(sectionEl) {
    const reloadEls = this.querySelectorAll(`[nss-cart-reload]`);

    reloadEls.forEach((reloadEl) => {
      const reloadID = reloadEl.getAttribute(`nss-cart-reload`),
        updatedEl = sectionEl.querySelector(`[nss-cart-reload="${reloadID}"]`);

      if (
        reloadID === `wrapper-footer` &&
        reloadEl.querySelector(`.swiper-initialized`) &&
        updatedEl &&
        updatedEl.querySelector(`nss-recommendations`)
      ) {
        return;
      }

      if (updatedEl) {
        reloadEl.replaceWith(updatedEl);
      } else {
        reloadEl.remove();
      }
    });
  }

  reloadItemList(sectionEl) {
    const productListEl = this.querySelector(`.nss-cart__items`),
      newProductListEl = sectionEl.querySelector(`.nss-cart__items`);

    productListEl.replaceWith(newProductListEl);
  }

  async handleATC(e) {
    const result = await this.apiAddToCart(e);
    if (this.debug) console.log(`[NSS][Cart Template] handleATC result:`, result);
    const sectionEl = await this.fetchCartSection();
    this.updateItemCount(sectionEl);
    this.reloadItemList(sectionEl);
    this.reloadElements(sectionEl);
    this.updateBlocks();
    this.refreshRecommendations();
    if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
  }

  updateBlocks() {
    this.els.buyboxSummaries.forEach((buyboxSummaryEl) => {
      const event = new CustomEvent("buyboxReload", {});
      buyboxSummaryEl.dispatchEvent(event);
    });

    this.els.buyboxStickyATCs.forEach((buyboxStickyATCEl) => {
      const event = new CustomEvent("buyboxReload", {});
      buyboxStickyATCEl.dispatchEvent(event);
    });
  }

  async handleRemove(e) {
    // const cartItemEl = e.target.closest(`.nss-cart__item`);
    const cartItemEl = e.target.closest(`[nss-cart-item-key]`);
    const itemKey = cartItemEl.getAttribute(`nss-cart-item-key`);
    const bundleKeys = cartItemEl.getAttribute(`nss-cart-item-bundle-keys`)?.split(",") || [];

    let updates = {};

    if (bundleKeys.length > 0) {
      bundleKeys.map((key) => {
        updates[key] = 0;
      });
    } else {
      updates[itemKey] = 0;
    }

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleRemove result:`, result);

    if (typeof result.status !== "undefined") {
      const cartItemParentEl = cartItemEl.parentElement,
        cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Remove failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();

      if (this.debug) console.log(`[NSS][Cart Template] Remove completed!`);
    }
  }

  async handleQtyIncrement(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
      itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
      qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let qtyMax = parseInt(qtyInputEl.getAttribute(`max`)),
      qtyCurrent = parseInt(qtyInputEl.value),
      qtyFinal = Math.min(qtyCurrent + 1, qtyMax),
      updates = {};

    updates[itemKey] = qtyFinal;

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleQtyIncrement result:`, result);

    if (typeof result.status !== "undefined") {
      const cartItemParentEl = cartItemEl.parentElement,
        cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Quantity increment failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();

      if (this.debug) console.log(`[NSS][Cart Template] Quantity increment completed!`);
    }
  }

  async handleQtyDecrement(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
      itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
      qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let qtyMin = parseInt(qtyInputEl.getAttribute(`min`)),
      qtyCurrent = parseInt(qtyInputEl.value),
      qtyFinal = Math.max(qtyCurrent - 1, qtyMin),
      updates = {};

    if (qtyFinal <= 0) {
      this.handleRemove(e);
      return;
    }

    updates[itemKey] = qtyFinal;

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleQtyDecrement result:`, result);

    if (typeof result.status !== "undefined") {
      const cartItemParentEl = cartItemEl.parentElement,
        cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();

      if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement completed!`);
    }
  }

  async handleBXSY(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
      itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
      qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let targetQty = e.target.getAttribute(`nss-bxsy-qty`),
      qtyMax = parseInt(qtyInputEl.getAttribute(`max`)),
      qtyFinal = Math.min(targetQty, qtyMax),
      updates = {};

    updates[itemKey] = qtyFinal;

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleBXSY result:`, result);

    if (typeof result.status !== "undefined") {
      const cartItemParentEl = cartItemEl.parentElement,
        cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Buy X, Save Y failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();

      if (this.debug) console.log(`[NSS][Cart Template] Buy X, Save Y completed!`);
    }
  }

  async handleFrequencyUpgrade(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
      itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
      qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`),
      sellingPlanId = e.target.getAttribute(`nss-selling-plan-id`);

    let qtyCurrent = parseInt(qtyInputEl.value),
      changes = {};

    changes["id"] = itemKey;
    changes["quantity"] = qtyCurrent;
    changes["selling_plan"] = sellingPlanId;

    const result = await this.apiChange(changes);
    if (this.debug) console.log(`[NSS][Cart Template] handleFrequencyUpgrade result:`, result);

    if (typeof result.status !== "undefined") {
      const cartItemParentEl = cartItemEl.parentElement,
        cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Upgrade frequency failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);

      if (this.debug) console.log(`[NSS][Cart Template] Upgrade frequency completed!`);
    }
  }

  async handleFrequencyChange(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
      itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
      qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let sellingPlanId = e.target.value;
    if (e.target.hasAttribute(`nss-selling-plan-id`)) {
      sellingPlanId = e.target.getAttribute(`nss-selling-plan-id`);
    }

    let qtyCurrent = parseInt(qtyInputEl.value),
      changes = {};

    changes["id"] = itemKey;
    changes["quantity"] = qtyCurrent;
    changes["selling_plan"] = sellingPlanId;

    const result = await this.apiChange(changes);
    if (this.debug) console.log(`[NSS][Cart Template] handleFrequencyChange result:`, result);

    if (typeof result.status !== "undefined") {
      const cartItemParentEl = cartItemEl.parentElement,
        cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Change frequency failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);

      if (this.debug) console.log(`[NSS][Cart Template] Change frequency completed!`);
    }
  }

  startItemLoading(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`);
    if (!cartItemEl) return;
    cartItemEl.setAttribute(`nss-cart-item-loading`, true);
  }

  async refreshCart() {
    const sectionEl = await this.fetchCartSection();
    this.updateItemCount(sectionEl);
    this.reloadItemList(sectionEl);
    this.reloadElements(sectionEl);
    this.refreshRecommendations();
    if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
  }

  initCartTemplate() {
    // Attach 'submit' events to nss-main as delegator
    const mainEl = document.querySelector(`[nss-main]`);

    window.NSS_REFRESH_AND_OPEN_CART = () => {
      this.refreshCart();
    };

    // Document-level listening for ATC events
    document.addEventListener(`submit`, (e) => {
      if (
        e.target.classList.contains(`shopify-product-form`) ||
        e.target.getAttribute(`action`) === `/cart/add`
      ) {
        e.preventDefault();
        if (this.debug) console.log(`[NSS][Cart Template] ATC form intercepted!`);
        this.handleATC(e);
      }
    });

    document.addEventListener(`click`, (e) => {
      let clickedName = e.target.getAttribute(`name`);

      if (this.debug) console.log(`[NSS][Cart Template] clickedName:`, clickedName);

      if (clickedName === "add") {
        e.preventDefault();
        if (this.debug) console.log(`[NSS][Cart Template] ATC button click intercepted!`);
        const fakeEvent = {
          target: e.target.closest(`form`),
        };
        this.handleATC(fakeEvent);
      }
    });

    // Attach other events to nss-cart-drawer as delegator
    this.addEventListener(`click`, (e) => {
      if (this.debug) console.log(`[NSS][Cart Template] CLicked, e.target:`, e.target);

      if (e.target.hasAttribute(`nss-frequency-drop-down`)) {
        e.target.classList.toggle(`nss-active`);
      }

      let eventType = e.target.getAttribute(`nss-cart-event`);

      switch (eventType) {
        case "bxsy-btn":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Buy X, Save Y event!`);
          this.startItemLoading(e);
          this.handleBXSY(e);
          break;

        case "remove":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Remove event!`);
          this.startItemLoading(e);
          this.handleRemove(e);
          break;

        case "qty-increment":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Quantity increment event!`);
          this.startItemLoading(e);
          this.handleQtyIncrement(e);
          break;

        case "qty-decrement":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement event!`);
          this.startItemLoading(e);
          this.handleQtyDecrement(e);
          break;

        case "frequency-upgrade":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Frequency upgrade event!`);
          this.startItemLoading(e);
          this.handleFrequencyUpgrade(e);
          break;

        case "frequency-change":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Frequency change event!`);
          this.startItemLoading(e);
          this.handleFrequencyChange(e);
          break;
      }
    });

    this.addEventListener(`change`, (e) => {
      let eventType = e.target.getAttribute(`nss-cart-event`);

      switch (eventType) {
        case "frequency-change":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Frequency change event!`);
          this.startItemLoading(e);
          this.handleFrequencyChange(e);
          break;
      }
    });

    // prepareRecommendations
    this.prepareRecommendations();
  }

  refreshRecommendations() {
    const productRecommendationsEls = document.querySelectorAll(`[nss-recommendations-id]`);
    productRecommendationsEls.forEach((productRecommendationsEl) => {
      const url = productRecommendationsEl.dataset.url;
      const id = productRecommendationsEl.getAttribute(`nss-recommendations-id`);

      productRecommendationsEl.setAttribute(`nss-recommendations-loading`, true);

      fetch(url)
        .then((response) => {
          productRecommendationsEl.setAttribute(`nss-recommendations-loading`, false);
          return response.text();
        })
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(`[nss-recommendations-id="${id}"]`);

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsEl.innerHTML = recommendations.innerHTML;
            productRecommendationsEl.style.display = `flex`;
          }
        })
        .catch((e) => {
          productRecommendationsEl.style.display = `none`;
          console.error(e);
        });
    });
  }

  prepareRecommendations() {
    const productRecommendationsEls = document.querySelectorAll(`[nss-recommendations-id]`);
    productRecommendationsEls.forEach((productRecommendationsEl) => {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsEl);

        const url = productRecommendationsEl.dataset.url;
        const id = productRecommendationsEl.getAttribute(`nss-recommendations-id`);
        productRecommendationsEl.setAttribute(`nss-recommendations-loading`, true);

        if (this.debug) console.log(`[NSS][Cart Template] Recommendations url:`, url);
        if (this.debug) console.log(`[NSS][Cart Template] Recommendations id:`, id);

        fetch(url)
          .then((response) => {
            productRecommendationsEl.setAttribute(`nss-recommendations-loading`, false);
            return response.text();
          })
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(`[nss-recommendations-id="${id}"]`);

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsEl.innerHTML = recommendations.innerHTML;
              productRecommendationsEl.style.display = `flex`;
            } else {
              productRecommendationsEl.style.display = `none`;
            }
          })
          .catch((e) => {
            productRecommendationsEl.style.display = `none`;
            console.error(e);
          });
      };
      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: "0px 0px 200px 0px",
      });
      observer.observe(productRecommendationsEl);
    });
  }
}

let elementName = `nss-cart-template`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCartTemplate);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
